import { CustomInput as InputForm } from "@/components/Input";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { useCardBrand } from "@/utils/useCardBrand";
import { Flex, Image, InputGroup, InputRightElement, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction, useState } from "react";

type DebitFormProps = {
  Total: string;
  DCHolder: string;
  DCNumber: string;
  DCMonth: string;
  DCYear: string;
  DSCode: string;
  setDCH: Dispatch<SetStateAction<string>>;
  setDCN: Dispatch<SetStateAction<string>>;
  setDCM: Dispatch<SetStateAction<string>>;
  setDCY: Dispatch<SetStateAction<string>>;
  setDSC: Dispatch<SetStateAction<string>>;
};

function DebitForm({
  Total,
  DCHolder,
  DCMonth,
  DCNumber,
  DCYear,
  DSCode,
  setDCH,
  setDCM,
  setDCN,
  setDCY,
  setDSC
}: DebitFormProps) {
  const [CardIcon, setCardIcon] = useState(
    "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/card.svg"
  );

  useIsomorphicLayoutEffect(() => {
    if (DCNumber) {
      let CardBrand = useCardBrand(DCNumber);
      if (CardBrand) setCardIcon(CardBrand);
    }

    return () => {
      setCardIcon("https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/card.svg");
    };
  }, [DCNumber]);

  return (
    <Flex direction={"column"} gap={"10px"} mt={"1rem"}>
      {/* HOLDER NAME */}
      <Flex>
        <InputForm
          name="HolderName"
          type={"text"}
          placeholder={"TITULAR"}
          value={DCHolder}
          onChange={(e) => setDCH(e.target.value.toUpperCase())}
          borderColor={"gray.400"}
          size={"sm"}
          p={"0 0 0 10px"}
          width={"full"}
          height={"50px"}
        />
      </Flex>
      {/* CARD NUMBER */}
      <Flex>
        <InputGroup>
          <InputForm
            name="CardNumber"
            placeholder={"NÚMERO DO CARTÃO"}
            value={DCNumber}
            onChange={(e) => setDCN(e.target.value)}
            borderColor={"gray.400"}
            size={"sm"}
            p={"0 0 0 10px"}
            mask={"9999 9999 9999 9999"}
            type={"text"}
            width={"full"}
            height={"50px"}
          />
          <InputRightElement
            mr={".5rem"}
            my={"4px"}
            children={<Image src={CardIcon} width="50px" alt={"Alternative to Image"} />}
          />
        </InputGroup>
      </Flex>
      {/* EXPIRE DATE [MONTH & YEAR] */}
      <Flex gap={"10px"}>
        <InputForm
          name="ExpireMonth"
          placeholder={"MÊS VENCIMENTO"}
          flex={1}
          value={DCMonth}
          onChange={(e) => setDCM(e.target.value)}
          borderColor={"gray.400"}
          size={"sm"}
          p={"0 0 0 10px"}
          mask={"99"}
          type={"text"}
          width={"full"}
          height={"50px"}
        />
        <InputForm
          name="ExpireYear"
          placeholder={"ANO VENCIMENTO"}
          flex={1}
          value={DCYear}
          onChange={(e) => setDCY(e.target.value)}
          borderColor={"gray.400"}
          size={"sm"}
          p={"0 0 0 10px"}
          mask={"9999"}
          type={"text"}
          width={"full"}
          height={"50px"}
        />
      </Flex>
      {/* SECURITY CODE */}
      <Flex>
        <InputForm
          name="SecurityCode"
          placeholder={"CÓDIGO DE SEGURANÇA"}
          value={DSCode}
          onChange={(e) => setDSC(e.target.value)}
          borderColor={"gray.400"}
          size={"sm"}
          p={"0 0 0 10px"}
          mask={"999"}
          type={"text"}
          width={"full"}
          height={"50px"}
        />
      </Flex>
      <Text textStyle="Bold" mt={"10px"} color="gray.700">
        TOTAL:{" "}
        <Text as="span" textStyle="Bold" color="blue.900">
          {Total}
        </Text>
      </Text>
    </Flex>
  );
}
export { DebitForm };
